import 'common/css/app.css'
import './index.css'
import {baseUrl} from 'common/js/global.js'

$(function() {
  getNews(1,true)
})

// 获取新闻
window.getNews = function(pageNum,initFlag) {
  var params = {
    pageNum: pageNum,
    pageSize: 6
  }
  $.get(baseUrl + '/api/website/activitys',params,function(data){
    if(data.errorCode == 0 ) {
      var dataList = data.data.list
      var html = ''
      var pages = data.data.pages
      for(var i = 0; i< dataList.length;i++) {
        dataList[i].introduction = dataList[i].introduction?dataList[i].introduction:''
        html += '<li class="list-group-item">'+
        '<a href="'+dataList[i].infoUrl+'"target="blank"><div class="clearfix">'+
          '<div class="left">'+
            '<img src="'+dataList[i].infoPic+'">'+
          '</div>'+
          '<div class="right">'+
            '<h2 class="tit">'+dataList[i].infoHead+'</h2>'+
            '<p class="time">'+dataList[i].infoPublishTime+'</p>'+
            '<div class="content">'+dataList[i].introduction+'</div>'+
          '</div>'+
        '</div></a>'+
      '</li>'
      }
      $('#newsWrapper').html(html)
      if(initFlag) {
        var pageHtml = '<li><a onClick="pageChage(1)">&laquo;</a></li>'
        for(var j = 1; j <= pages;j++) {
          if(pageNum == j) {
            pageHtml += '<li class="active" data-page="'+j+'"><a onClick="pageChage('+j+')">'+j+'</a></li>'
          }else{
            pageHtml += '<li data-page="'+j+'"><a onClick="pageChage('+j+')">'+j+'</a></li>'
          }
        }
        pageHtml += '<li><a onClick="pageChage('+pages+')">&raquo;</a></li>'
        $('.pagination-wrapper .pagination').html(pageHtml)
      }else{
        $('.pagination-wrapper .pagination').find('li').each(function() {
          if($(this).attr('data-page') == pageNum) {
            $(this).addClass('active').siblings().removeClass('active')
          }
        })
      }
    }
  })
}

window.pageChage = function(num) {
  getNews(num,false)
}


// WEBPACK FOOTER //
// ./src/moreActivity/index.js